export const SECURITY_NUMBER_NUMBER_OF_DIGITS = 9;

export interface ITrusteeCardData {
  ssn?: string;
  trusteeName?: string;
  isRemove?: boolean;
  isOptionDisabled?: boolean;
}
export interface ITrusteeCardinputValidationData {
  decedentName: string;
  decedentSSN: string;
  clientName: string;
  clientSSN: string;
}
